import styled from "styled-components";

export const AnchorInput = styled.input`
  min-width: 1rem;
`;

export const AnchorLabel = styled.label`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const AnchorTooltip = styled.div`
  visibility: hidden;
  position: absolute;
  z-index: 3;

  display: flex;
  align-items: center;

  top: 90%;
  right: 10%;

  height: 1.5rem;
  padding: 5px;
  border-radius: 10px;

  background-color: gray;
  color: white;

  @media only screen and (max-width: 767px) {
    display: none;
  }
`;

export const AnchorCheckboxContainer = styled.div`
  display: flex;
  align-items: center;

  width: 70%;

  border-left: 1px solid rgb(230, 230, 230);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  &:hover ${AnchorTooltip} {
    visibility: visible;
  }

  ${(props) => `
     @media only screen and (max-width: 767px) {
        display:  ${props.isFocused ? "flex" : "none"};
        
        width: 100%;
        height: 2rem;
        line-height: 2rem;
        
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        
        color: rgb(51, 51, 51);
        background-color: rgb(245, 245, 245);
        z-index: 2;
     }
  `}
`;
